export function DisableWarn() {
  try {
    if (typeof window.console != "undefined") {
      //   window.console = {} as typeof console;
      //   window.console.log = function () {};
      window.console.debug = function () {};
      window.console.info = function () {};
      window.console.warn = function () {};
    }
  } catch (ex) {
    ex = null;
  }
  try {
    // console = {} as typeof console;
    // console.log = function () {};
    console.debug = function () {};
    console.info = function () {};
    console.warn = function () {};
    console.error = function () {};
  } catch (ex) {
    ex = null;
  }
}
